/**
 * panelTypeRegistry — Array/String/Module 타입별 설정 중앙 집중
 *
 * === 목적 ===
 * 기존에 58+ 군데에 산재된 `item.type === 'string' / 'module' / 'array'` if/else 체인을
 * 이 레지스트리 한 곳으로 통합한다.
 *
 * === 사용법 ===
 *   import { getPanelTypeConfig } from '@/features/panel-planning/utils/panelTypeRegistry';
 *   const cfg = getPanelTypeConfig(item.type);
 *   cfg.color  // '#1E88E5'
 *   cfg.icon   // 'mdi-current-ac'
 *
 * 새 타입이 추가되면 이 파일만 수정하면 된다.
 */

const ENTITY_TYPES = ['array', 'string', 'module'];

/**
 * @param {'array'|'string'|'module'} type
 * @returns {boolean}
 */
export function isValidPanelType(type) {
  return ENTITY_TYPES.includes(type);
}

/**
 * @param {string} type
 * @returns {Object} 해당 타입의 설정 (없으면 default)
 */
export function getPanelTypeConfig(type) {
  if (!isValidPanelType(type)) {
    return PANEL_TYPE.default;
  }
  return PANEL_TYPE[type];
}

export const PANEL_TYPE = {
  array: {
    color: '#FF9800',
    icon: 'mdi-view-grid',
    iconClass: 'tree-type-icon--array',
    labelKey: 'panelPlanning.typeArray',
    canRename: true,
    canMove: false,
    canDelete: true,
    moveMenuLabel: null,
    deleteLabelKey: 'panelPlanning.menuDelete'
  },

  string: {
    color: '#1E88E5',
    icon: 'mdi-current-ac',
    iconClass: 'tree-type-icon--string',
    labelKey: 'panelPlanning.typeString',
    canRename: true,
    canMove: true,
    canDelete: true,
    moveMenuLabel: 'panelPlanning.menuMoveArray',
    deleteLabelKey: 'panelPlanning.menuDelete'
  },

  module: {
    color: '#00897B',
    icon: 'mdi-alpha-m',
    iconClass: 'tree-type-icon--module',
    labelKey: 'panelPlanning.typeModule',
    canRename: true,
    canMove: true,
    canDelete: true,
    moveMenuLabel: 'panelPlanning.menuMoveString',
    deleteLabelKey: 'panelPlanning.menuDeleteModule'
  },

  /** fallback */
  default: {
    color: '#757575',
    icon: 'mdi-help-circle',
    iconClass: '',
    labelKey: '',
    canRename: false,
    canMove: false,
    canDelete: false,
    moveMenuLabel: null,
    deleteLabelKey: ''
  }
};

export default PANEL_TYPE;
